import { Decimal, LiquityStoreState } from "@liquity/lib-base";
import { useLiquitySelector } from "@liquity/lib-react";

const selector = ({
  accountBalance,
  collateralAllowance,
  trove,
}: LiquityStoreState) => ({
  accountBalance,
  collateralAllowance,
  trove,  // can then use trove to get trove.collateral, trove.debt and trove.status
});

type CollateralValidation = {
  isValid: boolean;
  hasApproved: boolean;
  hasEnoughCollateralToken: boolean;
  isWithdrawing: boolean;
  amountChanged: Decimal;
  maximumStake: Decimal;
  hasSetMaximumStake: boolean;
};

export const useCollateralValidationState = (amount: Decimal): CollateralValidation => {
  const { accountBalance, collateralAllowance, trove } = useLiquitySelector(selector);
  console.log("Validating Allowance with accountBalance = ",accountBalance.toString()," collateralAllowance = ",collateralAllowance.toString()," amount = ",amount.toString()," trove.collateral = ",trove.collateral.toString()) // JJ
  const isWithdrawing = trove.collateral.gt(amount);
  const amountChanged = isWithdrawing ? trove.collateral.sub(amount) : Decimal.from(amount).sub(trove.collateral);
  const maximumStake = trove.collateral.add(accountBalance);
  const hasSetMaximumStake = amount.eq(maximumStake);
  let hasEnoughCollateralToken = accountBalance.gt(amountChanged)

  if (isWithdrawing) {
    return {
      isValid: true,
      hasApproved: true,
      hasEnoughCollateralToken: true,
      isWithdrawing,
      amountChanged,
      maximumStake,
      hasSetMaximumStake
    };
  }
console.log("collateralAllowance = ",collateralAllowance.toString()," amountChanged = ",amountChanged.toString()) // JJ
  const hasApproved = !collateralAllowance.isZero && collateralAllowance.gte(amountChanged); 
  const hasEnoughCollateral = !accountBalance.isZero && accountBalance.gte(amountChanged);

  console.log("account balance = ",accountBalance.toString(),"  Collateral allowance = ", collateralAllowance.toString())  // JJ

  return {
    isValid: hasApproved && hasEnoughCollateral,
    hasApproved,
    hasEnoughCollateralToken,
    isWithdrawing,
    amountChanged,
    maximumStake,
    hasSetMaximumStake
  };
};
